import * as api from "@/api/williams/certificates";
import { ExpirationsFilters } from "@/api/williams/certificates";
import { queryKeys } from "../../queryKeys";
import { useInfiniteQuery } from "react-query";

const PAGE_SIZE = 100;

export function useExpirationsList(filters: Partial<ExpirationsFilters> = {}) {
  return useInfiniteQuery({
    queryKey: queryKeys.expirations.filter(filters),
    queryFn: ({ pageParam = 0 }) => {
      const skip = pageParam * PAGE_SIZE;
      return api.getExpirationList({ skip, take: PAGE_SIZE, ...filters });
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.results.length === PAGE_SIZE) {
        return allPages.length;
      }
    },
  });
}
